module.exports = __webpack_public_path__ + "img/tmx_store_huawei_jozsef_korut_small.14d7c975.jpg";